import { Component, Host, h, Prop } from "@stencil/core";

import { fixIEShadowDom } from "../../../utils/fix-ie-shadow-dom";

@Component({
    tag: "leichte-sprache-bubble",
    styleUrl: "leichte-sprache-bubble.scss",
})
export class LeichteSpracheBubble {
    @Prop() text: string;
    @Prop() variant: "user" | "bot" | "loading";

    render() {
        return (
            <Host>
                {this.variant === "loading" && (
                    <section class="loading" aria-hidden="true">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </section>
                )}
                {this.variant === "bot" && (
                    // Accessibility tests:
                    // - Can the screen reader focus on links inside innerHTML?
                    <section
                        class="bot"
                        innerHTML={fixIEShadowDom(
                            this.text,
                            "leichte-sprache-bubble"
                        )}
                    ></section>
                )}
                {this.variant === "user" && (
                    <section
                        class="user"
                        innerHTML={fixIEShadowDom(
                            this.text,
                            "leichte-sprache-bubble"
                        )}
                    ></section>
                )}
            </Host>
        );
    }
}
